
$(function() {

    if ( typeof SHOW_REGISTER != 'undefined' && SHOW_REGISTER ) {

        $( '#registerForm').css('display', 'block');
        $( '#loginForm').css('display', 'none');
    }

});